@if (markerBaseService.initialized) {
  <div (leafletMapReady)="onMapReady($event)"
       [leafletLayers]="markerBaseService.markers"
       [leafletOptions]="markerBaseService.options"
       [(leafletCenter)]="markerBaseService.center"
       [(leafletZoom)]="markerBaseService.zoom"
       class="map-container !z-0"
       leaflet>
  </div>
}

